/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaPersonalisationSettings model module.
 * @module model/AqaPersonalisationSettings
 * @version v0
 */
export default class AqaPersonalisationSettings {
  /**
   * Constructs a new <code>AqaPersonalisationSettings</code>.
   * @alias module:model/AqaPersonalisationSettings
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaPersonalisationSettings</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaPersonalisationSettings} obj Optional instance to populate.
   * @return {module:model/AqaPersonalisationSettings} The populated <code>AqaPersonalisationSettings</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaPersonalisationSettings();
      if (data.hasOwnProperty('dateFormatTarget'))
        obj.dateFormatTarget = ApiClient.convertToType(data['dateFormatTarget'], 'String');
      if (data.hasOwnProperty('accountDateFormat'))
        obj.accountDateFormat = ApiClient.convertToType(data['accountDateFormat'], 'String');
      if (data.hasOwnProperty('personDateFormat'))
        obj.personDateFormat = ApiClient.convertToType(data['personDateFormat'], 'String');
    }
    return obj;
  }
}

/**
 * Allowed values for the <code>dateFormatTarget</code> property.
 * @enum {String}
 * @readonly
 */
AqaPersonalisationSettings.DateFormatTargetEnum = {
  /**
   * value: "accountDateFormat"
   * @const
   */
  accountDateFormat: "accountDateFormat",

  /**
   * value: "personDateFormat"
   * @const
   */
  personDateFormat: "personDateFormat"
};
/**
 * @member {module:model/AqaPersonalisationSettings.DateFormatTargetEnum} dateFormatTarget
 */
AqaPersonalisationSettings.prototype.dateFormatTarget = undefined;

/**
 * @member {String} accountDateFormat
 */
AqaPersonalisationSettings.prototype.accountDateFormat = undefined;

/**
 * @member {String} personDateFormat
 */
AqaPersonalisationSettings.prototype.personDateFormat = undefined;

